<template>
  <div>
    <el-table
      class="coin-table"
      :data="addressList"
      :row-key="() => Math.random()"
      style="width: 100%"
    >
      <el-table-column label="用户Id" prop="userId"></el-table-column>
      <el-table-column label="币种类型" prop="coinType"></el-table-column>
      <el-table-column label="地址源" prop="source"></el-table-column>
      <el-table-column label="钱包地址" prop="address"></el-table-column>
      <el-table-column label="地址memo" prop="memo"></el-table-column>
      <el-table-column label="版本" prop="version"></el-table-column>
      <el-table-column label="时间">
        <template slot-scope="scope">{{scope.row.createTime | moment}}</template>
      </el-table-column>
      <el-table-column label="地址是否可用" prop="isActive">
        <template slot-scope="scope">{{scope.row.isActive}}</template>
      </el-table-column>
      <el-table-column label="是否支持充值" prop="canDeposit">
        <template slot-scope="scope">{{scope.row.canDeposit}}</template>
      </el-table-column>
    </el-table>
    <pagination
      :size="pagination.size"
      :page="pagination.page"
      :total="totalCount"
      @pageChanged="handlePageChanged"
    ></pagination>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations, mapState } from "vuex";
import Pagination from "components/pagination";

export default {
  name: "addressList",
  data() {
    return {
      sortable: ".coin-table"
    };
  },
  components: {
    Pagination
  },
  computed: {
    ...mapState("UserCoinAddress", ["addressList", "pagination", "totalCount"])
  },
  created() {
    this.handlePageChanged({ page: 1, size: 20});
  },
  methods: {
    ...mapActions("UserCoinAddress", ["list", "create"]),
    handlePageChanged(pagination) {
      this.$emit("refresh", { pagination });
    }
  }
};
</script>

<style lang="less" scoped>
.conf-table {
  margin-top: 20px;
}
.confirm-btn {
  margin-top: 10px;
}
</style>
